// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__2m1+Y","spin":"spinner_spin__NAsp1","grey":"spinner_grey__Nwbgc","white":"spinner_white__c53vR","black":"spinner_black__vNR-F"};